function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.9327 49.6167L30.6055 48.2829",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0664 49.6167L27.3936 48.2829",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0.752769H58V58.7788H0V0.752769Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_64_344)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.4141 32.464C18.8013 31.723 20.526 32.2478 21.2663 33.6362",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.5594 32.464C39.1721 31.723 37.4474 32.2478 36.707 33.6362",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.9994 40.2673C40.2962 39.4904 40.6528 38.6954 41.0917 37.8608L43.2327 33.7893C44.9109 30.5982 45.5819 26.8283 43.2805 23.9753L38.6475 18.2314C38.1247 17.5833 37.4229 17.1034 36.6295 16.8515L32.6365 15.5834C32.4659 15.5292 32.2855 15.5134 32.1081 15.5372C31.9307 15.5609 31.7608 15.6236 31.6104 15.7207C28.9107 17.4641 26.3671 15.6842 26.3784 15.6873C26.2305 15.6002 26.0658 15.5454 25.8952 15.5266C25.7246 15.5078 25.5519 15.5253 25.3886 15.5782L21.3758 16.8758C20.5969 17.1277 19.9075 17.5996 19.3907 18.2347L14.7187 23.9754C12.4174 26.8283 13.0883 30.5982 14.7664 33.7893L16.9075 37.8608C18.8918 41.6339 19.1953 44.5987 19.8815 48.7328L20.3303 51.4361C20.5368 52.6806 21.3102 53.7361 22.3907 54.3995C23.5622 55.1188 25.0257 55.1726 26.2764 54.6019L27.3559 54.1094C27.8719 53.8739 28.4325 53.752 28.9996 53.752C29.5668 53.752 30.1273 53.8739 30.6433 54.1094L31.7228 54.6019C32.9735 55.1726 34.437 55.1189 35.6086 54.3995C36.6891 53.7361 37.4623 52.6806 37.6689 51.4361L38.1178 48.7328C38.3991 47.0372 38.6163 45.5383 38.9113 44.0998",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.4183 46.3269C33.4183 48.7691 31.4393 50.749 28.9981 50.749C26.557 50.749 24.5781 48.7691 24.5781 46.3269C24.5781 43.8847 33.4183 43.8847 33.4183 46.3269Z",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.168 54.761C24.3276 56.6527 26.5035 57.9277 28.9988 57.9277C31.494 57.9277 33.67 56.6527 34.8296 54.761",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.5694 24.3636C46.5529 24.8838 49.9377 24.7761 52.1597 22.5495C54.9186 19.7851 56.175 16.411 56.7442 14.0557C57.0997 12.5844 55.9845 11.1697 54.4714 11.1815C48.3311 11.2296 42.3993 13.4158 37.6953 17.3645",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.3267 17.3843C15.6192 13.4233 9.67776 11.2296 3.52684 11.1815C2.01375 11.1698 0.898494 12.5843 1.25397 14.0557C1.82321 16.411 3.07961 19.7851 5.83846 22.5496C8.06047 24.776 11.4453 24.8839 14.4288 24.3636",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.9213 15.531C25.4987 12.0893 23.401 3.45206 12.9861 1.61846C11.9942 1.44381 11.4544 2.74793 12.2781 3.32773C15.7392 5.76471 20.5419 10.3813 20.5544 17.2407",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.443 17.2085C37.4705 10.3669 42.2632 5.76082 45.7188 3.32769C46.5425 2.74777 46.0028 1.44366 45.0108 1.6183C34.5835 3.45417 32.4932 12.11 32.0742 15.5433",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.7109 17.237C15.0498 18.2535 16.2788 19.4074 17.378 20.6798L17.387 20.6929",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.57812 12.2158L1.58198 12.2179L4.91743 13.0407C6.7284 13.4874 8.48145 14.1431 10.1414 14.9946",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.6211 20.6802C43.8853 16.905 48.2401 14.2363 53.0847 13.0424L56.4202 12.2204",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgGoats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_64_344",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 59
  }, _ref4), _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoats);
export default __webpack_public_path__ + "static/media/goats.f318cbe599e95a46bbbf662c1c05355e.svg";
export { ForwardRef as ReactComponent };